import { Icon } from '@aqarmap/aqarmap-ui';
const Image = ({ imgSrc }: { imgSrc: string }) => {
  return imgSrc ? (
    <img
      src={imgSrc}
      alt="Account-Img"
      className="w-[64px] h-[64px] rounded-full object-contain border border-gray"
    />
  ) : (
    <div className="rounded-full bg-gray_light_1 border border-gray w-[64px] h-[64px] element-center">
      <Icon name="user" className="text-gray__dark_1" />
    </div>
  );
};

export default Image;
